import cloneDeep from 'lodash/cloneDeep.js';
import isEmpty from 'lodash/isEmpty.js';
import merge from 'lodash/merge.js';

class QuizBuilder {
    constructor({ parent = null, store = null, quizType = '' }) {
        this.answer = {
            body: null,
            display_order: null,
            is_correct: null,
            parent,
            value: 0,
            question_id: null,
            type: null,
        };

        this.store = store;

        this.status = {
            answers: {},
            question: {},
            quiz: {},
        };

        this.quizType = quizType;
    }

    trueFalseAnswers() {
        const answers = [];
        const $true = cloneDeep(this.answer);
        const $false = cloneDeep(this.answer);

        $true.body = 'True';
        $true.display_order = String(0);

        answers.push($true);

        $false.body = 'False';
        $false.display_order = String(1);

        answers.push($false);

        return answers;
    }

    multipleChoiceAnswers() {
        const answers = [];
        const limit = 4;
        let i = 0;

        while (i < limit) {
            const choice = cloneDeep(this.answer);

            choice.display_order = String(i);

            answers.push(choice);

            i++;
        }

        return answers;
    }

    freeFormAnswers() {
        const free = cloneDeep(this.answer);
        free.display_order = 0;
        free.type = 'free_form';

        delete free.is_correct;

        return [free];
    }

    setMultipleCorrectAnswers(payload, answers, parent) {
        answers.forEach(answer => {
            let existInPayload = false;

            if (!isEmpty(payload)) {
                existInPayload = payload.some(item => item.display_order === answer.display_order);
            }

            if (existInPayload) answer.is_correct = true;

            if (!existInPayload) answer.is_correct = false;
        });

        this.store.commit('SET_QUESTION_FIELD', {
            order: parent,
            field: 'answers',
            value: answers,
        });
    }

    setSingleCorrectAnswer(payload, answers) {
        answers.forEach(answer => {
            if (answer.display_order !== payload.display_order) {
                this.store.commit('SET_ANSWER_FIELD', {
                    field: 'is_correct',
                    order: answer.display_order,
                    parent: answer.parent,
                    value: false,
                });
            }
        });

        this.store.dispatch('setAnswerField', {
            field: 'is_correct',
            order: payload.display_order,
            parent: payload.parent,
            value: true,
        });
    }

    validate({ type, item }) {
        if (type === 'question') return this.validateQuestion(item);

        if (type === 'answers') return this.validateAnswer(item.answers);

        if (type === 'quiz') return this.validateQuiz(item);

        return null;
    }

    validateQuestion(question) {
        if (!question.body) this.status.question.body = '*Question Body Required';

        if (
            question.type === 'multiple_choice_multiple_answer' &&
            !question.partial_credit &&
            !question.points &&
            this.quizType !== 'survey'
        ) {
            this.status.question.body = '*Total Points Required';
        }

        return this.validateAnswer(question.answers);
    }

    validateAnswer(payload) {
        const answers = cloneDeep(payload);

        answers.forEach(answer => (answer.errors = {}));

        if (payload.some(item => item.type === 'free_form')) return this.status;

        if (answers.length < 1) this.status.answers.min = '*One Answer Minimum';

        if (answers.some(item => !item.body)) {
            const bodyErrors = answers.filter(answer => !answer.body);

            bodyErrors.forEach(item => {
                item.errors.body = '*Answer Body Required';
            });

            this.status.answers.errors = bodyErrors;
        }

        if (this.quizType === 'survey') return this.status;

        if (answers.some(item => !item.value && typeof item.value !== 'number')) {
            const valueErrors = answers.filter(answer => !answer.value && typeof answer.value !== 'number');

            valueErrors.forEach(item => {
                item.errors.value = '*Answer Value Required';
            });

            if (isEmpty(this.status.answers.errors)) this.status.answers.errors = valueErrors;

            if (!isEmpty(this.status.answers.errors)) merge(this.status.answers.errors, valueErrors);
        }

        if (!answers.some(item => item.is_correct === true))
            this.status.question.correct = '*Question Must Have One Correct Answer';

        return this.status;
    }

    validateQuiz(quiz) {
        if (!quiz.title) this.status.quiz.title = '*Title Required';

        return this.status;
    }
}

export default QuizBuilder;
